/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import { withRouter } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import Spinner from '../../../../SharedModules/Spinner/Spinner';

import {
  updatUserDefaults,
  getUserDefaults,
  getRebateProgramCode,
  getClientCode,
  getAallPlanCode,
  getAllgroupCode,
  getCheckPayeeCode,
  getValidateCheckPayee,
  dispatchTabChanges,
  dispatchGetAllClientCode,
  dispatchGetAllplanCode,
  dispatchGetAllGroupCode
} from '../store/actions';
import UserDefaultForm from './UserDefaultForm';
import {
  closeTab,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { FAILED_MESSAGE_GENERIC } from '../../../../SharedModules/Errors/constantMessageData';

function UserDefault(props) {
  const dispatch = useDispatch();
  const getUserDefaultValues = (value) => dispatch(getUserDefaults(value));
  const getRebateProgramCodeValue = (values) =>
    dispatch(getRebateProgramCode(values));
  const getClientCodeValue = (value) => dispatch(getClientCode(value));
  const getAallPlanCodeValue = (value) => dispatch(getAallPlanCode(value));
  const getAllGroupCodeValue = (value) => dispatch(getAllgroupCode(value));
  const getAllCheckPayeeValue = () => dispatch(getCheckPayeeCode());
  const updateUserDefault = (value, loginId) =>
    dispatch(updatUserDefaults(value, loginId));
  const getValidateCheckPayeeValue = (value) =>
    dispatch(getValidateCheckPayee(value));
  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );
  const rebateProgramCode = useSelector(
    (state) => state.sharedState.UserDefaultReducer.rebateProgramCode
  );
  const clientCode = useSelector(
    (state) => state.sharedState.UserDefaultReducer.clientCode
  );
  const planCode = useSelector(
    (state) => state.sharedState.UserDefaultReducer.planCode
  );
  const groupCode = useSelector(
    (state) => state.sharedState.UserDefaultReducer.groupCode
  );
  const checkPayeeCode = useSelector(
    (state) => state.sharedState.UserDefaultReducer.checkPayeeCode
  );
  const update = useSelector(
    (state) => state.sharedState.UserDefaultReducer.update
  );
  const validateCheckPayee = useSelector(
    (state) => state.sharedState.UserDefaultReducer.validateCheckPayee
  );
  const tabChanges = useSelector(
    (state) => state.sharedState.UserDefaultReducer.tabChanges
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const [sucessMessage, setSucessMessage] = useState([]);
  const [errorMessage, setErrorMessage] = useState([]);
  const [save, setSaved] = useState(false);
  const [open, setOpen] = useState(false);
  const [dialogoMessage, setDialogMessage] = useState('');
  const [saveOrCancel, setSaveOrCancel] = useState('');
  const initializeValue = {
    // Plan Type
    planTypeCd: null,
    // Rebate Program
    rebateProgramCd: '-1',
    // Check Payee
    checkPayeeCd: '-1',
    // NDC Select Mode
    defNdcSelectModeCd: null,
    // Default Report Quarter Option
    defRptQtrSelectCd: null,
    // Default Invoice Select Mode
    defInvoiceSelectModeCd: null,
    // Quarter A/R Invoice Balance
    dispBalanceDueInvInd: 0,
    dispOverriddenInvInd: 0,
    dispPaidInFullInvInd: 0,
    // A/R NDC Balance Defaults:
    dispBalanceDueNdcInd: 1,
    dispOverriddenNdcInd: 1,
    dispPaidInFullNdcInd: 0,
    defDisputeResolutionInd: 0,
    // Account:
    viewPmtActInd: 0,
    viewIntActInd: 0,
    // Client
    clientId: '',
    // Group
    groupId: '',
    // Plan
    planId: '',
    printerIpAddrs: '',
  };
  const [isUserChangedValue, setIsUserChangedValue] = useState(false);
  const [openSave, setOpenSave] = useState({ open: false, cond: '' });
  const [values, setValues] = useState(initializeValue);
  const history = useHistory();
  const [willCloseTab, setWillCloseTab] = useState(false);
  // Triger only temp changes without API data loading when back from the other tab
  const [isTrigerTempChanges, setIsTrigerTempChanges] = useState(true);
  const onCancel = () => {
    setOpen(false);
    if (UserDefaultValues) {
      // Set Values from UserDefaultValues(Saved values) after the user cancel the changes
      setValues(UserDefaultValues);
      if (UserDefaultValues.planTypeCd) {
        getRebateProgramCodeValue(UserDefaultValues.planTypeCd);
      }
      // Set isUserChangedValue as false after the user cancel the changes
      setIsUserChangedValue(false);
      getClientCodeValue({
        rebateProgramCd:UserDefaultValues?.rebateProgramCd
      });
      getAllGroupCodeValue({
        clientId: UserDefaultValues?.clientId,
        groupId: null,
      });
      getAallPlanCodeValue({
        clientId:  UserDefaultValues?.clientId,
        groupId: UserDefaultValues?.groupId,
      });
    }
  };

  const handleClickOpenCancel = () => {
    setOpen(true);
    setDialogMessage('unsaved changes will be discarded.');
  };

  const onSave = (value) => {
    setOpenSave({ open: false, cond: '' });
    const userIdUC = logInUser;
    setSucessMessage([]);
    setErrorMessage([]);
    updateUserDefault(
      {
        userId: userIdUC ? userIdUC.toUpperCase() : logInUser,
        planTypeCd: values.planTypeCd,
        rebateProgramCd: values.rebateProgramCd,
        defNdcSelectModeCd: values.defNdcSelectModeCd,
        defInvoiceSelectModeCd: values.defInvoiceSelectModeCd,
        clientId: values.clientId,
        groupId: values.groupId,
        planId: values.planId,
        checkPayeeCd: values.checkPayeeCd,
        defRptQtrSelectCd: values.defRptQtrSelectCd,
        defProviderIdTypeCd: null,
        dispBalanceDueNdcInd: values.dispBalanceDueNdcInd,
        dispOverriddenNdcInd: values.dispOverriddenNdcInd,
        dispPaidInFullNdcInd: values.dispPaidInFullNdcInd,
        defDisputeResolutionInd: values.defDisputeResolutionInd,
        viewPmtActInd: values.viewPmtActInd,
        viewIntActInd: values.viewIntActInd,
        dispBalanceDueInvInd: values.dispBalanceDueInvInd,
        dispOverriddenInvInd: values.dispOverriddenInvInd,
        dispPaidInFullInvInd: values.dispPaidInFullInvInd,
        printerIpAddrs: values?.printerIpAddrs || '',
        lastUpdateUserId: userIdUC ? userIdUC.toUpperCase() : logInUser,
      },
      userIdUC
    );
    setSaved(true);
    // Set isUserChangedValue as false after the user save the changes
    setIsUserChangedValue(false);
  };

  const handleCloseSave = () => {
    setOpenSave({ open: false, cond: '' });
  };

  const handleClickOpenSave = () => {
    if (
      validateCheckPayee.message &&
      validateCheckPayee.message.length &&
      validateCheckPayee.message.includes('Warning!')
    ) {
      setOpenSave({ open: true, cond: 'saveWarningCheckPayee' });
    } else {
      setOpenSave({ open: true, cond: 'saveWarning' });
    }
  };

  const saveTabChangesTemp = (isChanged) => {
    dispatch(
      dispatchTabChanges({
        values: isChanged ? values : null,
        isUserChangedValue: isChanged,
      })
    );
  };

  /** handling refresh functionality */
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/userDefault' && isUserChangedValue) {
          item.isFormDirty = true;
        } else if (item.navTo === '/userDefault') item.isFormDirty = false;
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [isUserChangedValue]);

  /** close popup on click button */
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/userDefault' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/userDefault' && item.isFormSave) {
          item.isFormSave = false;
          setIsUserChangedValue(false);
          onSave();
          setWillCloseTab(true);
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  const onChangeValuesHandler = (e, property, checkBox = false) => {
    setIsUserChangedValue(true);
    setIsTrigerTempChanges(false);
    if (property === 'clientId') {
      dispatch(dispatchGetAllplanCode([]))
      getAllGroupCodeValue({
        clientId: e.target.value,
        groupId: null,
      });
    }
    if(property ==='groupId' ){
      getAallPlanCodeValue({
        clientId:   values?.clientId,
        groupId: e.target.value,
      });
    }
    if (property === 'rebateProgramCd') {
        dispatch(dispatchGetAllplanCode([]))
        dispatch(dispatchGetAllGroupCode([]))
      getClientCodeValue({
        rebateProgramCd: e.target.value,
      });
    }
    if (property === 'planTypeCd') {
      // chamge rebate program code
      dispatch(dispatchGetAllClientCode([]))
        dispatch(dispatchGetAllplanCode([]))
        dispatch(dispatchGetAllGroupCode([]))
      getRebateProgramCodeValue(e.target.value);
    }
    if (checkBox) {
      let number = e;
      if (number === 0) {
        number = 1;
      } else {
        number = 0;
      }
      setValues({ ...values, [property]: number });
    } else {
      setValues({
        ...values,
        [property]: e.target.value,
        ...('rebateProgramCd' in values &&
          property === 'rebateProgramCd' && { clientId: '-1',groupId:'-1',planId: '' }),
        ...('planTypeCd' in values &&
          property === 'planTypeCd' && { rebateProgramCd: '-1' }),
      });
    }
    if(property === 'clientId' && e.target.value=='-1'){
      setValues({...values,clientId: '-1',groupId:'-1',planId: ''})
    }
    if(property ==='groupId' && e.target.value=='-1'){
      setValues({...values,groupId:'-1',planId: ''})
      
    }
  };
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  useEffect(() => {
    if (tabChanges?.isUserChangedValue && tabChanges.values) {
      //setIsUserChangedValue(tabChanges?.isUserChangedValue);
      if(tabChanges.values?.rebateProgramCd=="-1"||!tabChanges.values?.rebateProgramCd){
        dispatch(dispatchGetAllClientCode([]))
        dispatch(dispatchGetAllplanCode([]))
        dispatch(dispatchGetAllGroupCode([]))
      }
      if(tabChanges.values?.clientId=="-1"||!tabChanges.values?.clientId){
        dispatch(dispatchGetAllplanCode([]))
        dispatch(dispatchGetAllGroupCode([]))
      }
      if(tabChanges.values?.groupId=="-1"||!tabChanges.values?.groupId){
        dispatch(dispatchGetAllplanCode([]))
      }
      setValues(tabChanges.values);
      setIsTrigerTempChanges(true);
      setIsUserChangedValue(true);
    } else {
      getUserDefaultValues(logInUser);
      setIsTrigerTempChanges(false);
    }
    getAllCheckPayeeValue();
    handleScrollToEvent();
  }, []);

  useEffect(() => {
    if (UserDefaultValues &&!tabChanges?.isUserChangedValue) {
      if (UserDefaultValues.planTypeCd) {
        getRebateProgramCodeValue(UserDefaultValues.planTypeCd);
      }
      if (UserDefaultValues.rebateProgramCd ) {
        getClientCodeValue({
          rebateProgramCd: UserDefaultValues.rebateProgramCd,
        });
      }
      if (UserDefaultValues.groupId && UserDefaultValues.clientId)
        getAallPlanCodeValue({
          clientId: UserDefaultValues.clientId,
          groupId: UserDefaultValues.groupId,
        });
      if (UserDefaultValues.clientId)
        getAllGroupCodeValue({
          clientId: UserDefaultValues.clientId,
          groupId: null,
        });
      if (!isTrigerTempChanges) setValues(UserDefaultValues);
    }
  }, [UserDefaultValues])

  useEffect(() => {
    if (
      values.clientId &&
      values.groupId &&
      isUserChangedValue &&
      values.clientId !== '-1' &&
      values.groupId !== '-1'
    ) {
      getAallPlanCodeValue({
        clientId: values.clientId,
        groupId: values.groupId,
      });
    }
  }, [values.clientId, values.groupId]);

  useEffect(() => {
    if (isUserChangedValue) {
      getValidateCheckPayeeValue({
        clientId: values.clientId,
        groupId: values.groupId,
        planId: values.planId,
        rebateProgramCd: values.rebateProgramCd,
        checkPayeecode: values.checkPayeeCd,
      });

      /** Check if the values are equal with the saved or initial values: Set isUserChangedValue as false if those are equal */
      const initialValues = UserDefaultValues ?? initializeValue;
      if (_.isEqual(values, initialValues)) {
        setIsUserChangedValue(false);
        saveTabChangesTemp(false);
      } else {
        saveTabChangesTemp(true);
      }
    } else {
      saveTabChangesTemp(false);
    }
  }, [values]);

  useEffect(() => {
    getUserDefaultValues(logInUser);
    if (save && update && update.message && update.status === '001') {
      if (willCloseTab) {
        setWillCloseTab(false);
        dispatch(dispatchTabChanges({}));
        closeTab('/userDefault', history, dispatch);
      }
      setSucessMessage(['System successfully saved the information.']);
      setIsUserChangedValue(false);
      dispatch(dispatchTabChanges({}));
      setSaved(false);
    } else if (save && update && update.message) {
      setErrorMessage([FAILED_MESSAGE_GENERIC])
    }
  }, [update]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Spinner load={spinnerLoader} />
      <UserDefaultForm
        values={values}
        onChangeValuesHandler={onChangeValuesHandler}
        initializeValue={initializeValue}
        rebateProgramCode={rebateProgramCode}
        clientCode={clientCode}
        planCode={planCode}
        groupCode={groupCode && groupCode.data ? groupCode.data : []}
        checkPayeeCode={checkPayeeCode}
        onSave={onSave}
        dialogoMessage={dialogoMessage}
        spinner={spinnerLoader}
        sucessMessage={sucessMessage}
        errorMessage={errorMessage}
        onCancel={onCancel}
        handleClickOpenSave={handleClickOpenSave}
        handleClickOpenCancel={handleClickOpenCancel}
        open={open}
        openSave={openSave}
        handleClose={handleClose}
        handleCloseSave={handleCloseSave}
        UserDefaultValues={UserDefaultValues}
        isUserChangedValue={isUserChangedValue}
      />
    </div>
  );
}
export default withRouter(UserDefault);
